// shared/supabaseConfig.js
const SUPABASE_URL = 'https://hujhkxmnjpnsqbspekkw.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1amhreG1uanBuc3Fic3Bla2t3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjYyMzE0MTAsImV4cCI6MjA0MTgwNzQxMH0.VfJ4qyB-9QHgjQVIN1M9d5TT_suKeQPksgq5XjvaL2c';

module.exports = {
  SUPABASE_URL,
  SUPABASE_ANON_KEY
};